<script>
	export let variant

	import ExperimentVariantParam from "./ExperimentVariantParam.svelte"

	import { createEventDispatcher } from 'svelte'

	const dispatch = createEventDispatcher()

	function switchState() {
        variant.state = variant.state === "active" ? "paused" : "active"
	}

	function onNameChanged(index) {
		const params = variant.params
		if (index < params.length - 1) {
            return
        }
		variant.params = [...params, {name: "", value: ""}]
	}

	function removeParam(index) {
		const params = variant.params
		if (params.length === 1) {
			return
		}
		variant.params = params.filter((e, i) => i !== index)
	}

	function removeVariant() {
		dispatch("remove")
	}
</script>

<div class="card darken-1">
	<div class="card-content card-title {variant.state === 'active' ? 'teal' : 'grey'} lighten-3">
		<div class="row">
			<div class="col s4">
				<input type="text" class="validate" bind:value="{variant.name}">
			</div>
			<div class="col s6"></div>
			<div class="col s1">
				<button class="btn-floating orange" on:click={switchState}>
                    <i class="material-icons">
                        {#if variant.state === 'active'}pause{:else}play_arrow{/if}
                    </i>
				</button>
			</div>
			<div class="col s1">
				<button class="btn-floating red" on:click={removeVariant}><i class="material-icons">clear</i></button>
			</div>
		</div>
	</div>
	<div class="card-content">
		{#each variant.params as param, index (index)}
            <ExperimentVariantParam bind:param idOnPage={`${variant.id}__${index}`} on:nameChanged={() => onNameChanged(index)} on:remove={() => removeParam(index)}/>
		{/each}
	</div>
  </div>
<style>
	
</style>